module.exports = __webpack_public_path__ + "img/scratch_icon.9df26605.png";